import { render, staticRenderFns } from "./SetDecision.vue?vue&type=template&id=4d0c9412&scoped=true&"
import script from "./SetDecision.vue?vue&type=script&lang=js&"
export * from "./SetDecision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0c9412",
  null
  
)

export default component.exports